import styled from '@emotion/styled';
import { breakpoints } from '../../utils/styleguide';

const DesktopVerticalCenter = styled.div`
  ${breakpoints.desktop} {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export default DesktopVerticalCenter;
